function resolveProfileIdentifier(props) {
  let data = props
  if (data?.user) data = { ...props, ...data.user }

  const profileId = data?.username || data?.id || data?.userId
  if (!profileId) return null

  return encodeURIComponent(profileId)
}

export function urlSafeProfileBasePath(props) {
  const profileId = resolveProfileIdentifier(props)
  if (!profileId) return '/profile'
  return `/profile/${profileId}`
}

export function urlSafeProfilePath(props) {
  let data = props
  if (data?.user) data = { ...props, ...data.user }

  const profileType = data?.profileType || 'driver'
  const basePath = urlSafeProfileBasePath(data)

  return `${basePath}/${profileType}`
}
